import type { HelpFile } from '../../types/help'
import { RehireReviewTestIds } from '../../../testids/RehireReviewTestIds'

export const rehireReviewHelp: HelpFile = {
  docPage: '/docs/admin/rehire-review',
  texts: {
    [RehireReviewTestIds.rehireReviewList]:
      'Warteschlange möglicher Wiedereinstellungen — Kandidaten entstehen, wenn ein Inbound-Sync einen eingehenden Datensatz einer TERMINATED-Identität zuordnet.',
    [RehireReviewTestIds.rehireReviewLoading]: null,
    [RehireReviewTestIds.rehireReviewEmpty]:
      'Keine Wiedereinstellungs-Kandidaten entsprechen den aktuellen Filtern.',
    [RehireReviewTestIds.colSourceConnector]:
      'Inbound-Konnektor, der diese mögliche Wiedereinstellung erkannt hat.',
    [RehireReviewTestIds.colMatchedIdentity]:
      'Bestehende TERMINATED-Identität, der der eingehende Datensatz zugeordnet wurde.',
    [RehireReviewTestIds.colNewEntryDate]:
      'Vorgeschlagenes Eintrittsdatum aus dem eingehenden Datensatz.',
    [RehireReviewTestIds.colDetectedAt]:
      'Zeitpunkt, zu dem der Konnektor diesen Kandidaten erstmals markiert hat.',
    [RehireReviewTestIds.colStatus]:
      'Entscheidungsstatus des Kandidaten — offen, akzeptiert oder abgelehnt.',
    [RehireReviewTestIds.colDecidedBy]:
      'Identität oder Konnektor, die die Entscheidung erfasst hat.',
    [RehireReviewTestIds.badgeDecidedByConnector]:
      'Entscheidung wurde vom Konnektor anhand seiner Match-Regeln automatisch getroffen, nicht durch einen menschlichen Prüfer.',
  },
}
